import { cloneElement, FC } from 'react';

import { Box, Flex, Tooltip } from '@bonusly/design-system';

import { Reaction } from './lib/reaction';
import { ReactionStackTooltip } from './reaction-stack-tooltip';
import { coinStyle } from './styles';

interface ReactionStackProps {
	reactions: Reaction[];
}

export const ReactionStack: FC<ReactionStackProps> = ({ reactions }) => {
	return (
		<Flex>
			{reactions.map((reaction, index) => (
				<Tooltip whiteSpace="pre-line" key={index} label={<ReactionStackTooltip coin={reaction.coin} type={reaction.type} />}>
					<Box
						data-testid={`reaction-type-${reaction.type}`}
						__css={{
							_notFirst: {
								marginInlineStart: '-4px',
							},
						}}
					>
						{cloneElement(<reaction.coin />, coinStyle)}
					</Box>
				</Tooltip>
			))}
		</Flex>
	);
};
